export const getFormatDate = (date) => {
  if (!date) return;
  const cleanDateParh = (dateParth) => dateParth.replace(/,/g, '');
  const [fullDate] = date.split(' ');
  const arrayDate = fullDate.split('');

  const year = `${arrayDate.slice(0, 4)}`;
  const formattedYear = cleanDateParh(year);
  const month = `${arrayDate.slice(4, 6)}`;
  const formattedMonth = cleanDateParh(month);
  const day = `${arrayDate.slice(6, 8)}`;
  const formattedDay = cleanDateParh(day);

  const formattedDate = `${formattedYear}-${formattedMonth}-${formattedDay}`;

  return formattedDate;
};
